<template>
    <div>
      <div :class="['livePoint',{'notShow':notShow}]">
        <div class="titleimg">
            <img src="./tittle.png" />
        </div>
        <div class="w90">
          <!-- <img class="label" src="./label.png" /> -->
            <img class="point20" src="./1.png" />
        <div class="inputs">
          <!-- <input v-model="clientName" @input="clientName=clientName.replace(/[^\u4E00-\u9FA5]/g,'')"  placeholder="请输入真实姓名"/> -->
          <input v-model="clientName" placeholder="请输入真实姓名"/>
        </div>
        <div class="inputs"><input v-model="mobile" @input="mobile=mobile.replace(/[^\d]/g,'')" maxlength="11" placeholder="请输入手机号码"/>
        </div>
        <div class="inputContent">
            <div class="inputs codeinputs"><input placeholder="请输入验证码" v-model="code"/></div>
            <button class="getVerCode" v-if="verifyMsg!='验证码'">{{ verifyMsg }}</button>
            <button class="getVerCode" v-else-if="cangetVerCode" @click="getVerCode">{{ verifyMsg }}</button>
            <button class="getVerCode grayCode" v-else>{{ verifyMsg }}</button>
        </div>
        <div class="inputContent">
            <div class="inputs codeinputs"><input placeholder="请输入图形验证码" v-model="imgCode"/></div>
            <div class="getVerCode"><img @click="getVerCodeUrl" :src="verCodeUrl" /></div>
        </div>
        <div class="button">
            <div @click="apply">一键申领</div>
        </div>
        
        <div class="submittext">点击一键申请，未注册的手机号将一键注册东航金融APP</div>
        </div>
        <div class="dlContent">
            
        <div class="dl">
            <img src="./dl.png" />
        </div>
        <div class="dlImg">
            <img @click="Download" src="./Andriod.png" />
            <img @click="Download" src="./iOS.png" />
        </div>
        </div>
        <div class="bigcontent">
            <div class="bigimg"><img src="./dlb.png" /></div>
        </div>
        <div class="staticimg">
            <img src="./buttom.png" />
        </div>
    </div>
    
    <alert :showModal.sync="showAlert">{{ alertMessage }}</alert>
</div>
</template>
<script>

    /* eslint-disable */
    import ajax from '@/common/ajax/ajax'
import alert from "@/components/alert/alert";
    export default {
      data () {
        return {
          contract: '',
          clientName: '',
          code: '',
          imgCode:"",
          mobile: '',
          original: true,
          alertMessage:"",
      showAlert: false,
      showInfo: false,
      verifyMsg: "验证码",
      wait:30,
      verCodeUrl:"",
      notShow:false,
      cangetVerCode:false
        }
    },
    
  components: { alert },
  watch: {
    showAlert(val) {
      if(!val) {
        this.getVerCodeUrl()
      }
    },
    mobile(val) {
      if(val.length==11) {
        this.cangetVerCode = true
      } else {
        this.cangetVerCode = false
      }
    }
  },
  mounted() {
      this.getTimeIsOver()
      this.getVerCodeUrl()
  },
    methods: {
        
      Download(){
        this.$router.push('/download')
      },
        async getTimeIsOver() {
            var liveBroadcast = this.$route.query.liveBroadcast
            ajax.getTimeIsOver(liveBroadcast).then(
            data => {
              if (data.data.resultStatus === '0') {
                  if(data.data.data=='1') {
                    this.notShow = false
                  } else {
                      this.notShow = true
                      this.alertMessage = '页面无效'
                      this.showAlert = true;
                  }
              } else {
                this.notShow = true
                this.alertMessage = '页面无效'
                this.showAlert = true;
              }
            }
          ).catch((err)=>{
            this.notShow = true
            this.alertMessage = "页面无效"
            this.showAlert = true
         }) 
        },
        async getVerCodeUrl() {
            
          ajax.getImageverificationCode().then(
            data => {
              if (data.data.resultStatus === '0') {
                this.verCodeUrl = data.data.data
              } else {
                this.alertMessage = data.data.resultMessage
                this.showAlert = true;
              }
            }
          ).catch((err)=>{
            this.alertMessage = "发送失败"
            this.showAlert = true
         }) 
        },
        multiNum(val) {
          return (isNaN(Number(val))?0:val)
        },
        closeModel() {
            this.showInfo = false
        },
        stopMP() {},
        getVerCode () {
            if(!this.mobile) {
              this.alertMessage = '请输入手机号码'
              this.showAlert = true;
              return
            }
            
          var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
          if (!reg_tel.test(this.mobile)) {
            this.alertMessage = "请输入正确的手机号码";
            this.showAlert = true;
            return;
          }
          var info = {
            mobile: this.mobile,
            type: 1003
          }
          ajax.sendVerifyCode(info).then(
            data => {
              if (data.data.resultStatus === '0') {
                  // this.alertMessage = data.data.resultMessage
                  // this.showAlert = true;
                  this.time()
              } else {
                this.alertMessage = data.data.resultMessage
                this.showAlert = true;
              }
            }
          ).catch((err)=>{
          this.alertMessage = "发送失败"
          this.showAlert = true
         }) 
        },
        
        time () {
        if (this.wait === 0) {
          this.verifyMsg = '验证码'
          this.wait = 30
        } else {
          this.verifyMsg = this.wait + '秒后重发'
          this.wait--
          setTimeout(()=> {
            this.time()
          }, 1000)
        }
      },
        apply () {
          if (!this.clientName||this.clientName.length<2) {
            this.alertMessage = "请输入真实姓名";
            this.showAlert = true;
            return;
          }
          var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
          if (!reg_tel.test(this.mobile)) {
            this.alertMessage = "请输入正确的手机号码";
            this.showAlert = true;
            return;
          }
          if (!this.code) {
            this.alertMessage = "验证码不能为空";
            this.showAlert = true;
            return;
          }
          if (!this.imgCode) {
            this.alertMessage = "图形验证码不能为空";
            this.showAlert = true;
            return;
          }
          var info = {
            clientName:this.clientName,
            mobile:this.mobile,
            dynamicCode:this.imgCode,
            verificationCode:this.code,
            source:this.$route.query.proID,
            liveBroadcast:this.$route.query.liveBroadcast
          }
          let formData = new FormData();
          
        Object.keys(info || {}).forEach((item) => {
          if (info[item]) formData.append(item, info[item])
        });
          ajax.byListBroadcast(formData).then((data) => {
          if(data&&data.data&&data.data&&data.data.resultStatus == 0 ) {
            this.alertMessage = data.data.data;
            this.showAlert = true;
          } else {
            this.alertMessage = data.data.resultMessage
            this.showAlert = true
            }
        }).catch((err)=>{
          this.alertMessage = '申请失败'
          this.showAlert = true
          // alert(err)
         }) 
        }
    }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .livePoint {
        background-image: url(./bg.png), linear-gradient(#00050e 60%, #062580);
        background-repeat: no-repeat;
        background-size: contain;
    }

    .titleimg {
        width: 80vw;
        margin: 0 auto;
        box-sizing: content-box;
    }

    .titleimg img {
        margin-top: 40px;
        width: 100%;
    }

    .staticimg {
        width: 90vw;
        margin: 0 auto;
        padding-bottom: 20px;

    }

    .staticimg img {
        width: 100%;
    }

    .bigimg {
        width: 100%;
    }

    .bigimg img {
        width: 100%;
    }

    .bigcontent {
        width: 100%;
    }
    .w90 {
        width: 94vw;
        background: #06266a;
        /* background: #666; */
        border-radius: 5px;
        margin: 30px auto 20px auto;
        position: relative;
        padding: 3vw;
    }
    .label {
        position: absolute;
        width: 80px;
        left: -9px;
        top:-9px;
    }
    .point20 {
        width: 60vw;
        display: block;
        margin: 10px auto 15px auto;
    }
    
  .inputs
    position relative
    margin-top 10px
    input::-webkit-input-placeholder
      color #bebebe
    input
      width 88vw
      padding-left 15px
      margin-bottom 0
      height 40px
      line-height 40px
      border none
      letter-spacing 1px
      border-radius 5px
      box-shadow none
      outline none
    img
      width 7vw
      position absolute
      left 8vw
      top 8px
  .getVerCode
      position absolute
      font-size 4vw
      height 40px
      line-height 40px
      top 0px
      width 25vw
      right 0
      background-image linear-gradient(#e8c765, #f5e9a8)
      color #ffffff
      border none
      margin 0
      padding 0
      border-radius 5px
  .grayCode
    background #ddd
  .inputContent
    position: relative;
  .codeinputs
    input
      width 60vw
.button
  text-align center
  padding-top 15px
  width 100vw
  margin-left -6vw
  height 50px
  box-sizing content-box
  background-image url(./button.png)
  background-repeat no-repeat
  background-size cover
  div
    width 100%
    height 50px
    line-height 50px
    color #352f4e
    font-size 18px
    font-weight 900
    border none
    padding 0
.submittext {
    color: #e8d7b8;
    font-size: 14px;
    text-align: center;
    margin: 15px 0 10px 0;
}
.getVerCode img {
    height: 100%;
    width: 100%;
    vertical-align: top;
}
.notShow {
    display: none;
}
.dlContent {
    position: relative;
}
.dl {
    width: 94%;
    margin: 0 auto;
}
.dl img {
    width: 100%;
}
.dlImg {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 20px;
}
.dlImg img {
    width: 16vw;
    margin: 0 8vw;
}
</style>



// WEBPACK FOOTER //
// index.vue?0b9016a0